export const notificationsConstant = {
  GET_ALL_REQUEST: 'NOTIFICATIONS_GET_ALL_REQUEST',
  GET_ALL_SUCCESS: 'NOTIFICATIONS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'NOTIFICATIONS_GET_ALL_FAILURE',
}
